<template>
  <div class="rewRoules">
    <div class="returnButton" @click="CloseDialog">
      <i class="el-icon-arrow-left"></i>
      返回
    </div>
    <!-- 提交表单 -->
    <div class="form-box">
      <div class="box">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择用户角色" prop="CustomType">
            <el-select
              v-model="ruleForm.CustomType"
              placeholder="请选择用户角色"
              style="width: 100%"
            >
              <el-option
                v-for="item in useRoleForm"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择用户行为" prop="BehaviorType">
            <el-select
              v-model="ruleForm.BehaviorType"
              placeholder="请选择用户行为"
              @change="behaviorTypeChange"
              style="width: 100%"
            >
              <el-option
                v-for="item in userBehaviorListForm"
                :key="item.BehaviorTypeID + item.BehaviorTypeName"
                :label="item.BehaviorTypeName"
                :value="Number(item.BehaviorTypeID)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.BehaviorType === 4 || ruleForm.BehaviorType === 5"
            label="指定地址"
            prop="TargetAddress"
          >
            <el-input
              placeholder="请填写文章内部链接地址"
              v-model="ruleForm.TargetAddress"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 400px"
            v-if="ruleForm.BehaviorType === 4 || ruleForm.BehaviorType === 5"
            label="完成时限"
            prop="TimeLimit"
          >
            <div style="display: flex">
              <span>文章发布:</span>
              <el-input
                type="number"
                :min="0"
                placeholder="请输入天数"
                v-model.number="ruleForm.TimeLimit"
                style="margin: 0px 10px; width: 270px"
              ></el-input>
              <span>天内</span>
            </div>
          </el-form-item>
          <el-form-item label="获取分值" prop="Scores">
            <el-input
              type="number"
              placeholder="请输入分值"
              v-model.number="ruleForm.Scores"
              @input="scoresChange"
            ></el-input>
          </el-form-item>
          <el-form-item label="每日积分上限" prop="SupperLimit">
            <el-input
              type="number"
              placeholder="请输入分值"
              :disabled="setSupperLimit"
              v-model.number="ruleForm.SupperLimit"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <el-button @click="CloseDialog">取 消</el-button>
          <el-button type="primary" @click="confirmAction">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  AddCreditRuleReq,
  UpdateCreditRuleReq,
  GetCreditRuleReq,
  GetBehaviorListReq,
} from '../../../api/pointsRule.js';
const { ruleForm, useRoleForm, userBehaviorListForm } = require('./index');
export default {
  name: 'OperationManageEdit',
  components: {},
  data() {
    const blurText = (rule, value, callback) => {
      const boolean = new RegExp('^[1-9][0-9]*$').test(value);
      if (value === '') {
        callback(new Error('请输入天数'));
      } else if (!boolean) {
        callback(new Error('请输入正整数'));
      } else {
        return callback();
      }
    };
    return {
      rules: {
        CustomType: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
        BehaviorType: [{ required: true, message: '请选择用户行为', trigger: 'change' }],
        TargetAddress: [{ required: true, message: '请填写文章内部链接地址', trigger: 'blur' }],
        TimeLimit: [{ validator: blurText, trigger: 'blur' }],
        Scores: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        SupperLimit: [{ required: true, message: '请输入分值', trigger: 'blur' }],
      }, // 表单校验规则
      ruleForm, // 表单数据
      useRoleForm, // 表单用户选择
      userBehaviorListForm, // 表单用户类型
      setSupperLimit: false, // 每日积分上限是否可以编辑
      breadcrumb: [
        {
          menu_name: '设置',
        },
        {
          menu_name: '积分设置',
          menu_path: 'huizhi_PointsRule',
        },
      ],
    };
  },
  created() {
    this.breadcrumb.push({ menu_name: this.$route.query.id ? '编辑积分规则' : '新建积分规则' });
    this.g_breadcrumb(this.breadcrumb);
    if (this.$route.query.id) {
      this.getneewList();
    } else {
      this.getBehaviorList();
    }
  },
  mounted() {},
  methods: {
    // // 获取需要的数据
    getneewList() {
      return Promise.all([this.getBehaviorList(), this.getDetial()]);
    },
    // 获取用户行为类型列表
    async getBehaviorList() {
      await GetBehaviorListReq({})
        .then((res) => {
          const data = res.Datas;
          this.userBehaviorListForm = data;
        })
        .catch((res) => {
          this.$message({
            message: res.message,
            type: 'error',
          });
          console.log(res);
        });
    },
    // 用户行为选择，应该清空隐藏的数据
    behaviorTypeChange(value) {
      if (value && value !== 4 && value !== 5) {
        this.ruleForm.TargetAddress = '';
        this.ruleForm.TimeLimit = '';
        this.setSupperLimit = false;
      } else {
        this.setSupperLimit = true;
      }
      this.ruleForm.Scores = '';
      this.ruleForm.SupperLimit = '';
    },
    // 特殊行为下，每日积分上限自动获取分值
    scoresChange(val) {
      if (this.ruleForm.BehaviorType === 4 || this.ruleForm.BehaviorType === 5) {
        this.ruleForm.SupperLimit = val;
      }
    },
    // 弹窗确认
    confirmAction() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.$route.query.id) {
            // 新建
            AddCreditRuleReq(this.ruleForm)
              .then((res) => {
                console.log(res);
                this.$message({
                  message: '新建成功',
                  type: 'success',
                });
                this.CloseDialog();
              })
              .catch((res) => {
                this.$message({
                  message: res.message,
                  type: 'error',
                });
                console.log(res.message);
              });
          } else {
            // 编辑
            UpdateCreditRuleReq({ data: { ...this.ruleForm } })
              .then((res) => {
                console.log(res);
                this.$message({
                  message: '编辑成功',
                  type: 'success',
                });
                this.CloseDialog();
              })
              .catch((res) => {
                this.$message({
                  message: res.message,
                  type: 'error',
                });
                console.log(res.message);
              });
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 弹窗关闭
    CloseDialog() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        ID: '', // 编辑ID
        CustomType: '', // 用户角色
        BehaviorType: '', // 用户行为
        TargetAddress: '', // 指定地址
        TimeLimit: '', // 完成时限
        Scores: '', // 获取分值
        SupperLimit: '', // 每日积分上限
      };
      this.setSupperLimit = false;
      // this.$router.go(-1);
      this.g_tourl(`/saas/huizhi/PointsRule.html`);
    },
    // 获取详情信息
    async getDetial() {
      const parmas = {
        ID: this.$route.query.id,
      };
      await GetCreditRuleReq(parmas)
        .then((res) => {
          const data = res?.data;
          if (data.BehaviorType === 4 || data.BehaviorType === 5) {
            this.setSupperLimit = true;
          }
          this.ruleForm = {
            ID: data.ID, // 编辑ID
            CustomType: data.CustomType, // 用户角色
            BehaviorType: data.BehaviorType, // 用户行为
            TargetAddress: data.TargetAddress, // 指定地址
            TimeLimit: data.TimeLimit, // 完成时限
            Scores: data.Scores, // 获取分值
            SupperLimit: data.SupperLimit, // 每日积分上限
          };
        })
        .catch((res) => {
          this.$message({
            message: res.message,
            type: 'error',
          });
          console.log(res);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.rewRoules {
  .returnButton {
    cursor: pointer;
    margin: 16px 0;
  }
  .form-box {
    padding: 24px;
    background: #f7f9fc;
    .box {
      background: #fff;
      padding: 21px 0px 24px 16px;
      width: 100%;
      .footer {
        margin: 150px 0px 0px 30px;
      }
    }
  }
  ::v-deep .el-form-item__content {
    width: 400px;
    .el-input {
      width: 200px;
      max-width: 200px;
    }
    .el-input__inner {
      height: 36px;
    }
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-button {
    width: 100px;
    height: 36px;
  }
}
</style>
